<template>
  <div class="reset-password">
    <div class="title">تغییر رمز عبور</div>

  <template v-if="change">
    <label>
      <custom-input @showPassword="changeType" :type="type" placeholder="رمز عبور" auth="auth" :passwordlogo="true" @getValue="setPass"/>
    </label>
    <label>
      <custom-input @showPassword="changeRep" :type="type" placeholder="رمز عبور" auth="auth" :passwordlogo="true" @getValue="setRepeat"/>
    </label>
    <button @click="checkPassword" class="blue-btn"> تایید</button>
  </template>
    <template v-else >
      <div class="timer">
        <p class="text-info">کد ارسال شده به ایمیل خود را وارد کنید</p>
        <span v-if="finished">0:00</span>
        <span v-else>{{display}}</span>
      </div>

      <div class="code-input">
        <label >کدارسالی:</label>
        <CodeInput
            class="code-input"
            @change="onChange"
            @complete="submit"
            :fields="num"
            ref="code-input"
        />
      </div>
      <button v-if="!finished" @click.prevent="submit" class="blue-btn"> تایید</button>
      <button v-else @click.prevent="resetCode" class="blue-btn">ارسال مجدد</button>

    </template>
  </div>
</template>

<script>
import CodeInput from 'vue-verification-code-input'
import { DateTime, Duration } from "luxon";
import CustomInput from "../tools/custom-input";
export default {
  name: "reset-password",

  components: {
    CustomInput,
    CodeInput
  },

  data(){
    return{
      change:true,
      type: "password",
      now: DateTime.local().set({ milliseconds: 0 }),
      end: DateTime.local().set({ milliseconds: 0 }).plus({ seconds: 5 }),
      tick: null,
      num: 6,
      passError: "",
      otp: {
        code: "",
        email: this.state.userInfo.email || this.$cookies.get("username") || "",
        mobile: this.state.userInfo.mobile || this.$cookies.get("mobile") || "",
        password: "",
      },
      repeat: "",
    }
  },
  watch: {
    now() {
      if (this.finished) {
        clearInterval(this.tick);
      }
    },
  },

  methods:{
    changeType() {

      if (this.type === 'password') {
        this.type = 'text'
      } else if (this.type === 'text') {
        this.type = 'password'
      }
    },
    changeRep() {

      if (this.type === 'password') {
        this.type = 'text'
      } else if (this.type === 'text') {
        this.type = 'password'
      }
    },
    setPass(value) {
      this.otp.password = value;
    },
    setRepeat(value) {
      this.repeat = value;
    },

    //repeat password Guard
    async checkPassword() {
      if (!this.repeat || !this.otp.password) {
        this.passError = "رمز اجباری می باشد";
        this.$error("", this.passError);
      } else if (this.repeat !== this.otp.password) {
        this.passError = "رمز های عبور باید یکی باشند";
        this.$error("خطای تکرار", this.passError);
      } else {
        if (this.otp.password.length < 8) {
          this.passError = "رمز حداقل باید 8 کارکتر باشد";
          this.$error("", this.passError);
        } else if (!this.$validPass(this.otp.password)) {
          this.passError = "رمز باید ترکیبی از حرف بزرگ و کوچک باشد";
          this.$error("", this.passError);
        } else {
          this.change=false;
          return (this.passError = "" );
        }
      }
    },

    //check password Guard

    //submit code and password and email to BackEnd
    async submit() {
      await this.checkPassword();

      if (!this.passError) {
        const res = await this.$axios.post("/users/reset-password/", this.otp);
        if (res) {
          this.$error("رمز عبور با موفقیت تغییر پیدا کرد", "", "success");
          await this.$router.push("/auth/login");
        }
      }
    },

    onChange(e) {
      console.log(e)
      this.otp.code = e;
    },

    //reset password send again
    async resetCode() {
      this.state.loading = true
      await this.$axios.post(`/users/resend-otp-code?email=${this.$cookies.get('username')}`)
      this.$error('کد جدید  ' +'  ارسال شد.', '', 'success')
      this.$cookies.set('username', this.state.userInfo.email)
      //codes that will reset our code
      if (this.now >= this.end) {
        this.now = DateTime.local().set({ milliseconds: 0 });
        this.end = DateTime.local()
            .set({ milliseconds: 0 })
            .plus({ seconds: 120 });
        this.tick = setInterval(() => {
          this.now = DateTime.local().set({ milliseconds: 0 });
        }, 1000);
      }
    },
  },
  mounted() {
    // if (!this.$cookies.isKey("username")) {
    //   this.$router.push("/login");
    // }

      this.now = DateTime.local().set({ milliseconds: 0 });
      this.end = DateTime.local()
          .set({ milliseconds: 0 })
          .plus({ seconds: 120 });
      this.tick = setInterval(() => {
        this.now = DateTime.local().set({ milliseconds: 0 });
      }, 1000);


    this.tick = setInterval(() => {
      this.now = DateTime.local().set({ milliseconds: 0 });
    }, 1000);
  },
  computed: {
    remaining() {
      return this.end.diff(this.now).toObject();
    },
    display() {
      return Duration.fromObject(this.remaining).toFormat("mm:ss");
    },
    finished() {
      return this.now >= this.end;
    },
  },
}
</script>

<style lang="scss" scoped>
.code-input{
  display: flex;
  flex-direction: column;
  gap: 10px;
  label{
    display: flex;
    font-size: clamp(0.75rem, 1.2vw, 0.5rem);
  }
}
.reset-password {
  display: flex;
  flex-direction: column;
  gap: 30px;
  direction: rtl;
  color: #FBFBFD;
  justify-content: center;
  align-items: center;

  .title{
    font-size: clamp(18px , 2vw , 22px);
    font-weight: bold;
  }

  .text-info{
    font-size: clamp(12px , 2vw , 14px);
    text-align: right;
    width:100%;
  }

  button{
    width: 100%;
  }

  label{
    position: relative;
    width: 100%;
    img{
      position: absolute;
      left: 16px;
      top: 35%;
    }
  }
}
</style>